import type { BackendRouteDefinition } from '../types';

export const voidFinalizedInvoiceRoute = {
  body: (request: { invoiceId: string; voidReason?: string }) => ({
    ...(request.voidReason ? { voidReason: request.voidReason } : {}),
  }),
  method: 'POST',
  params: (request: { invoiceId: string }) => ({
    invoiceId: request.invoiceId,
  }),
  path: '/firms/invoice-voids/:invoiceId',
  transport: 'api',
} as const satisfies BackendRouteDefinition;

export const restoreVoidedInvoiceRoute = {
  body: (request: { invoiceId: string; operationId: string }) => ({
    operationId: request.operationId,
  }),
  method: 'POST',
  params: (request: { invoiceId: string }) => ({
    invoiceId: request.invoiceId,
  }),
  path: '/firms/invoice-voids/:invoiceId/restore',
  transport: 'api',
} as const satisfies BackendRouteDefinition;
